import AbstractHeader from './AbstractHeader'

export default class MobileHeaderAlt extends AbstractHeader {
    constructor() {
        super($('#shead-mb'), 'shead-mb')
        this.menuButton = this.find('topBar-mbutton')
        this.searchButton = this.find('menu-searchButton')
        this.regionButton = this.find('menu-regionButton')

        this.topBar = this.find('topBar')
        this.listSection = this.find('list')
        this.searchSection = this.find('search')
        this.regionSection = this.find('regions')

        this.bindControls()
        this.root.removeClass('s-hidden')
    }

    limitSearchHeight() {
        const substruct = this.topBar.outerHeight()
            + this.search.head.outerHeight()
            + this.searchSection.find('.submenuBackButton').outerHeight()
        this.search.resultsWrapper.css({
            height: window.innerHeight - substruct + 'px',
        })
    }

    hideMenus() {
        this.root.find('.s-open').removeClass('s-open')
        this.search.container.css({ height: 0 })
        this.regionSection.css({ height: 0 })
        this.searchButton.add(this.search.container).removeClass('s-open')
    }

    bindControls() {
        super.bindControls()

        if (navigator.userAgent.match(/iPhone|iPad/i)) {
            this.search.on('searchEnd', () => this.search.dismissKeyboard())
        }

        const bindSubmenu = ({ button, submenu, backButton }, onopen = () => {}, onclose = () => {}) => {
            button.on('click', event => {
                event.preventDefault()
                if (button.hasClass('s-open')) {
                    button.add(submenu).removeClass('s-open')
                    if (typeof onclose === 'function') {
                        onclose()
                    }
                } else {
                    button.add(submenu).addClass('s-open')
                    if (typeof onopen === 'function') {
                        onopen()
                    }
                }
            })
            backButton.on('click', () => {
                button.add(submenu).removeClass('s-open')
                if (typeof onclose === 'function') {
                    onclose()
                }
            })
            return {
                button,
                submenu,
                backButton,
            }
        }


        let submenus = this.root.find('.submenuButton').toArray().map(btn => {
            let button = $(btn).add($(btn).siblings('a')),
                submenu = $(button).siblings('.sub-menu'),
                backButton = submenu.find('.submenuBackButton')
            return {
                button,
                submenu,
                backButton,
            }
        })

        submenus.forEach(bindSubmenu)

        bindSubmenu(
            {
                button: this.regionButton,
                submenu: this.regionSection,
                backButton: this.regionSection.find('.submenuBackButton'),
            },
            () => $(document.body).trigger('regionPicker/show'),
            () => $(document.body).trigger('regionPicker/hide'),
        )

        bindSubmenu(
            {
                button: this.searchButton,
                submenu: this.searchSection,
                backButton: this.searchSection.find('.submenuBackButton'),
            },
            () => setTimeout(() => this.search.input.trigger('focus'), 10),
            () => this.search.clear(),
        )


        this.menuButton.on('click', () => {
            if (this.menuButton.hasClass('s-open')) {
                this.listSection.css({ height: 0 })
                this.menuButton.add(this.listSection).removeClass('s-open')
                this.root.find('.submenuBackButton').trigger('click')
            } else {
                this.listSection.add(this.listSection.find('.sub-menu'))
                    .css({ height: `calc(100vh - ${this.topBar.outerHeight()}px)` })
                this.menuButton.add(this.listSection).addClass('s-open')
            }
        })
    }
}
